import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { Filter, FilterService } from "../shared";

@Component({
  selector: "filter-list",
  templateUrl: "./filter-list.component.html",
  styleUrls: ["./filter-list.component.scss"],
})
export class FilterListComponent implements OnInit {
  filters: Array<Filter>;
  filtersFiltered: Array<Filter> = [];
  reorder: boolean = false;
  draggedItem: number = null;

  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    private filterService: FilterService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Filtros - " + this.mainConfig.cmsName);

    this.filterService.getAll().subscribe((filters) => {
      this.filters = filters;
    });
  }

  dragItem(e: Event, i: number) {
    e.stopPropagation();
    this.draggedItem = i;
  }

  dropItem(e: Event, i: number) {
    e.stopPropagation();
    this.filtersFiltered = this.reorderItems(
      this.filtersFiltered,
      this.draggedItem,
      i
    );
    this.draggedItem = null;
    this.filterService.saveMultiple(this.filtersFiltered).subscribe();
  }

  cancelDrag() {
    if (this.draggedItem !== null) {
      this.draggedItem = null;
    }
  }

  private reorderItems(
    items: Array<any>,
    positionStart: number = null,
    positionEnd: number = null
  ) {
    if (positionStart != positionEnd) {
      let itemsCloned = items.slice();
      let itemSelected = items[positionStart];
      items = [];

      itemsCloned.forEach((item, i) => {
        if (positionStart > positionEnd) {
          if (i > positionStart || i < positionEnd) {
            items[i] = item;
          } else if (i == positionEnd) {
            items[i] = itemSelected;
            items[i + 1] = item;
          } else if (i != positionStart) {
            items[i + 1] = item;
          }
        } else {
          if (i < positionStart || i > positionEnd) {
            items[i] = item;
          } else if (i == positionEnd) {
            items[i] = itemSelected;
            items[i - 1] = item;
          } else if (i != positionStart) {
            items[i - 1] = item;
          }
        }
      });
    }

    items = items.map((x, y) => {
      x.position = y + 1;

      return x;
    });

    return items;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/filter-list/filter-list.component.ts